import { getContentPage, restoreContent } from '@/api/content';
import { ContentList, ContentState } from '@/types/content';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type ContentGetter = GetterTree<ContentState, RootState>;

const state: ContentState = {
  content_list: {
    data: [],
    current_page: 1,
    first_page_url: 'http://cms.test/api/content?page=1',
    from: 1,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: 'http://cms.test/api/content',
    per_page: 50,
    prev_page_url: null,
    to: 50,
    total: 0,
  },
  content_loading: true,
  show_deleted: false,
};

const getters: ContentGetter = {
  content: state => state.content_list.data,
  currentPage: state => state.content_list.current_page,
  contentLoading: state => state.content_loading,
  showDeleted: state => state.show_deleted,
  totalPages: state => state.content_list.last_page,
};

const actions: ActionTree<ContentState, RootState> = {
  async getPage(
    { commit, state },
    { page = 1, category = '*', terms = null },
  ): Promise<void> {
    commit('setContentLoading', true);
    commit(
      'setPage',
      await getContentPage(page, category, state.show_deleted, terms),
    );
  },
  async restoreContent({ commit }, id: string): Promise<void> {
    await restoreContent(id);
    commit('restoreContent', id);
  },
};

const mutations: MutationTree<ContentState> = {
  restoreContent(state: ContentState, id: string): void {
    const content = state.content_list.data.find(item => item.id === id);
    if (content) {
      content.deleted_at = null;
    }
  },

  setPage(state: ContentState, page: ContentList): void {
    Object.assign(state.content_list, page);
    state.content_loading = false;
  },

  setContentLoading(state: ContentState, status): void {
    state.content_loading = status;
  },

  toggleShowDeleted(state: ContentState): void {
    state.show_deleted = !state.show_deleted;
  },
};

const content: Module<ContentState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default content;
